const STORAGE_KEY = 'confirm_quotation_ids';

export function savePendingQuotationIds(ids: number[]): void {
  const normalized = [...new Set(ids.filter((id) => Number.isFinite(id) && id > 0))];
  if (!normalized.length) {
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
}

export function readPendingQuotationIds(): number[] | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return null;
    }
    const ids = parsed
      .map((value) => Number(value))
      .filter((id) => Number.isFinite(id) && id > 0);
    return ids.length ? ids : null;
  } catch {
    return null;
  }
}

export function clearPendingQuotationIds(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function appendPendingQuotationIdsForAuth(
  payload: Record<string, unknown>,
): Record<string, unknown> {
  const ids = readPendingQuotationIds();
  if (ids?.length) {
    payload['confirmQuotationIds'] = ids;
  }
  return payload;
}
